import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/price/返回顶部.svg'
import _imports_1 from '../assets/img/price/价格套餐.svg'
import _imports_2 from '../assets/img/price/功能对比.svg'


const _withScopeId = n => (_pushScopeId("data-v-27ab9f2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "price" }
const _hoisted_2 = {
  class: "price-banner banner",
  id: "one"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "warp outer-package" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "b global-title" }, "选择最合适的方案，享受最佳的体验")
], -1))
const _hoisted_4 = { class: "outer-package price-list" }
const _hoisted_5 = { class: "list-item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "标准版", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "specifications" }, "适用于个人或小型团队", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-price" }, [
  /*#__PURE__*/_createElementVNode("span", null, "¥ "),
  /*#__PURE__*/_createElementVNode("span", null, "0.25"),
  /*#__PURE__*/_createElementVNode("span", null, " /BHU")
], -1))
const _hoisted_11 = { class: "list-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "高级版", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "specifications" }, [
  /*#__PURE__*/_createTextVNode("适合于对团队协作和资源管理调 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 度有更高要求的团队或企业")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-price" }, [
  /*#__PURE__*/_createElementVNode("span", null, "¥ "),
  /*#__PURE__*/_createElementVNode("span", null, "0.5"),
  /*#__PURE__*/_createElementVNode("span", null, " /BHU")
], -1))
const _hoisted_15 = { class: "list-item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "企业版", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "specifications" }, [
  /*#__PURE__*/_createTextVNode("适合于对公有云资源管理以及企 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 业安全有更高要求的团队或企业")
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-price" }, [
  /*#__PURE__*/_createElementVNode("span", null, "¥"),
  /*#__PURE__*/_createElementVNode("span", null, "1.0"),
  /*#__PURE__*/_createElementVNode("span", null, "/BHU")
], -1))
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<div class=\"list-item\" data-v-27ab9f2c><p class=\"title\" data-v-27ab9f2c>私有化部署</p><span class=\"specifications\" data-v-27ab9f2c>适合对数据私密性和企业自有系 <br data-v-27ab9f2c> 统集成有更高要求的企业</span><div class=\"item-price\" data-v-27ab9f2c><span data-v-27ab9f2c></span><span data-v-27ab9f2c>详询定价</span><span data-v-27ab9f2c></span></div><div class=\"item-btn item-btn2 btn-animation1\" data-v-27ab9f2c>联系我们</div></div>", 1)
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div class=\"price-two outer-package\" data-v-27ab9f2c><ul class=\"two-item\" data-v-27ab9f2c><li data-v-27ab9f2c>3人以内可使用</li><li data-v-27ab9f2c>NoteBook &amp; IDP Kernel</li><li data-v-27ab9f2c>数据接入</li><li data-v-27ab9f2c>环境管理</li><li data-v-27ab9f2c>团队协作</li><li data-v-27ab9f2c>工作流</li></ul><ul class=\"two-item\" data-v-27ab9f2c><li data-v-27ab9f2c>无限制 团队成员数量</li><li data-v-27ab9f2c>包含标准版所有功能</li><li data-v-27ab9f2c>团队协作高级功能</li><li data-v-27ab9f2c>资源管理</li></ul><ul class=\"two-item\" data-v-27ab9f2c><li data-v-27ab9f2c>无限制 团队成员数量</li><li data-v-27ab9f2c>包含高级版所有功能</li><li data-v-27ab9f2c>资源管理高级功能</li><li data-v-27ab9f2c>企业安全高级功能</li></ul><ul class=\"two-item\" data-v-27ab9f2c><li data-v-27ab9f2c>无限制 团队成员数量</li><li data-v-27ab9f2c>包含企业版所有功能</li><li data-v-27ab9f2c>企业自有服务器部署</li><li data-v-27ab9f2c>企业内部系统深度集成</li><li data-v-27ab9f2c>专属技术支持</li></ul></div>", 1)
const _hoisted_21 = {
  class: "price-three outer-package",
  id: "two"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "global-title title" }, "价格套餐", -1))
const _hoisted_23 = { class: "content" }
const _hoisted_24 = {
  class: "price-four outer-package",
  id: "three"
}
const _hoisted_25 = /*#__PURE__*/_createStaticVNode("<p class=\"global-title title\" data-v-27ab9f2c>功能对比</p><p class=\"global-title table-title row\" data-v-27ab9f2c><span class=\"col-2\" data-v-27ab9f2c></span><span class=\"col-2\" data-v-27ab9f2c></span><span class=\"col-2\" data-v-27ab9f2c>标准版</span><span class=\"col-2\" data-v-27ab9f2c>高级版</span><span class=\"col-2\" data-v-27ab9f2c>企业版</span><span class=\"col-2\" data-v-27ab9f2c>私有化部署</span></p>", 2)
const _hoisted_27 = { class: "content-title" }
const _hoisted_28 = { class: "content-content" }
const _hoisted_29 = { class: "col-4" }
const _hoisted_30 = { class: "col-2 a" }
const _hoisted_31 = ["src"]
const _hoisted_32 = { class: "col-2 b" }
const _hoisted_33 = ["src"]
const _hoisted_34 = { class: "col-2 c" }
const _hoisted_35 = ["src"]
const _hoisted_36 = { class: "col-2 d" }
const _hoisted_37 = ["src"]
const _hoisted_38 = { class: "price-five" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TabsTitle = _resolveComponent("TabsTitle")!
  const _component_SecondFooter = _resolveComponent("SecondFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _hoisted_8,
          _hoisted_9,
          _hoisted_10,
          _createElementVNode("div", {
            class: "item-btn btn-animation2",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.routGo('/information')))
          }, "申请试用")
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _hoisted_13,
          _hoisted_14,
          _createElementVNode("div", {
            class: "item-btn btn-animation2",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.routGo('/information')))
          }, "申请试用")
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _hoisted_17,
          _hoisted_18,
          _createElementVNode("div", {
            class: "item-btn btn-animation2",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.routGo('/information')))
          }, "申请试用")
        ]),
        _hoisted_19
      ])
    ]),
    _hoisted_20,
    _createElementVNode("div", _hoisted_21, [
      _hoisted_22,
      _createElementVNode("div", _hoisted_23, [
        _createVNode(_component_TabsTitle)
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _hoisted_25,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filter, (block, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "content",
          key: index
        }, [
          _createElementVNode("p", _hoisted_27, _toDisplayString(block.title), 1),
          _createElementVNode("ul", _hoisted_28, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(block.list, (item, index) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "row",
                key: index
              }, [
                _createElementVNode("div", _hoisted_29, _toDisplayString(item.name), 1),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("img", {
                    src: item.version.substring(0,1) === '1'? require('../assets/img/price/对号.svg') : require('../assets/img/price/错号.svg'),
                    alt: ""
                  }, null, 8, _hoisted_31)
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("img", {
                    src: item.version.substring(1,2) === '1'? require('../assets/img/price/对号.svg') : require('../assets/img/price/错号.svg'),
                    alt: ""
                  }, null, 8, _hoisted_33)
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("img", {
                    src: item.version.substring(2,3) === '1'? require('../assets/img/price/对号.svg') : require('../assets/img/price/错号.svg'),
                    alt: ""
                  }, null, 8, _hoisted_35)
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("img", {
                    src: item.version.substring(3,4) === '1'? require('../assets/img/price/对号.svg') : require('../assets/img/price/错号.svg'),
                    alt: ""
                  }, null, 8, _hoisted_37)
                ])
              ]))
            }), 128))
          ])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_38, [
      _createElementVNode("div", {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.rollAssignMent('one')))
      }, [
        _hoisted_39,
        _createTextVNode(" 返回顶部 ")
      ]),
      _createElementVNode("div", {
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.rollAssignMent('two')))
      }, [
        _hoisted_40,
        _createTextVNode(" 价格套餐 ")
      ]),
      _createElementVNode("div", {
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.rollAssignMent('three')))
      }, [
        _hoisted_41,
        _createTextVNode(" 功能对比 ")
      ])
    ]),
    _createVNode(_component_SecondFooter)
  ]))
}